import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { useCallback, useEffect } from "react";
import { datasource } from "../datasource/datasource";
import { useAuth } from "@clerk/clerk-react";
import { useNavigate, useParams } from "react-router";
import { isProd } from "../isProd";
import useOrganziations from "../hooks/useOrganizations";
import { useShepherdGlobalState } from "../hooks/useShepherdGlobalState";

const publishableKey = isProd
  ? "pk_live_51QAb3iGTWCxfv4CSxRGvcAGva2noqucscn7ywY8QMZzyZ5Kkb6trQeV5Ns4fTiP88Li1Pn0lGGDl0Rw0PmmafwnX005ekl6Ze9"
  : "pk_test_51QAb3iGTWCxfv4CSDx6bx1si5vDTA0hHMXQsxrb5OS2IDiXLEI8zwsnXVvHUtaNSz5UC8kfJNbFyfblsT446kWs800MhPbogoC";

const stripePromise = loadStripe(publishableKey);

export const PaymentPage = () => {
  const nav = useNavigate();
  const org = useOrganziations((state) => state.activeOrganization);
  const setShouldOpenTour = useShepherdGlobalState(
    (state) => state.setShouldOpenTour
  );
  const shouldOpenTour = useShepherdGlobalState(
    (state) => state.shouldOpenTour
  );
  useEffect(() => setShouldOpenTour(true), []);
  const { type, period } = useParams();
  const { getToken } = useAuth();
  const fetchClientSecret = useCallback(async () => {
    const token = await getToken();
    let safeOrg = org;
    if (!safeOrg?.id) {
      const userOrgs = await datasource.getUserOrgs(token as string);
      if (!userOrgs.length) {
        nav("/signup");
      }
      safeOrg = userOrgs[0];
    }
    if (safeOrg.planTypeId !== 1) {
      nav("/auth/dashboard");
    }
    return datasource.getStripSessionSecretForCheckout(
      safeOrg.id,
      period === "annual",
      type === "unlimited",
      token as string
    );
  }, [getToken, datasource]);

  const options = { fetchClientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};
